import { z } from "zod";

// Route-local extension of the root inventorySearchSchema (routes/__root.tsx:43) — an optional
// lens perspective (category / source) narrowing the shared Havainnot query, carried from a
// judgment lens's "Havainnot ->" link and the cycle-ribbon / Signaalit "Näytä Havainnoissa"
// jump (optional `finding` id). Route-local rather than widening
// the root schema: ScopedLink's default `search` only forwards the root-owned inventory scope
// keys, not arbitrary leaf params (scoped-nav.tsx pickInventoryScope) — so this filter never
// survives an unrelated navigation (e.g. the plain left-nav Havainnot link) unless a caller
// explicitly sets it. Keeping it root-level would defeat
// that: every route's validateSearch would parse and keep it regardless of ScopedLink's merge
// logic — perspective is an optional server query param, never a second
// list.
//
// Lives here (not inline in routes/findings.tsx) so findings-search-schema.test.ts can import it
// without tripping react-refresh/only-export-components on the route file — and so it stays a
// plain, testable value in sync with FindingCategory (lib/api/building.ts). The #1353 bug was
// this enum silently drifting behind that union when "configuration" was added.
export const findingsSearchSchema = z.object({
  category: z
    .enum(["fault", "comfort", "data_quality", "opportunity", "configuration"])
    .optional(),
  source: z.enum(["equipment", "zone", "building"]).optional(),
  finding: z.string().min(1).optional(),
});
